import styled from 'styled-components'

const StyledPromoCodeInput = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;

  .btn {
    margin-left: 1rem;
  }

  .promo-input {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    max-width: 400px;
  }
`

export default StyledPromoCodeInput
